// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/styles/style_constants.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-family: "Poppins", "Nunito", -apple-system, BlinkMacSystemFont, 
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
}

html, body {
  font-family: inherit;
  font-weight: 400; /* Adjust as needed */
}
body {
  margin: 0; 
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html,body{
  height: 100%;
}
code {
  font-family: var(--font-family)
}

.logo-w{
  width: 135px;
}
li.cursor-pointer {
  cursor: pointer;
}
li.explorer-list-group {
  font-size: 0.9rem;  
}
li.explorer-list-group:hover{
  background-color: #021127;
  color: #e3f2fd;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: #f8f9fa;
  background: #212121;
  border-radius: 10px;
}
.nav-link-annotator{
  text-decoration: none;
  color: white;
  background: #0d6efd;
}

ul.p-tree-container, 
ul.p-treenode-children {
  padding-left: 0px;
}
ul.p-treenode-children{
  border-left: 1px solid #dcdcdc;
}
ul.p-treenode-children li{
  padding-left: 10px;
}
.p-treenode-content {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 0.9rem;
  width: 100%;
}
.p-tree .p-tree-container .p-treenode .p-treenode-content {
  border-radius: 6px;
  transition: box-shadow 0.2s;
  padding: 0.25rem;
 
}
svg.svg-icon.svg-file-type-icon {
  width: 1.15rem;
  height: 1.15rem;
  margin-right: 0.5rem;
}
svg.svg-file-explorer-icon{
  width: 4.5rem;
  height: 4.5rem;
  margin: 0;
}
.p-splitter {
  border: 0px solid #e5e7eb;
  background: #ffffff;
  border-radius: 0px;
  color: #4b5563;
}
.p-tree {
  border: 0px solid #e5e7eb;
  background: #ffffff;
  color: #4b5563;
  padding: 0.125rem;
  border-radius: 6px;
  height: 100%;
}
.svg-icon-backend-type {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  margin-right: .75rem;
}
.svg-icon-backend-menu {
  width: 18px;
  height: 22px;
  border-radius: 8px;
  margin-right: 15px;
  margin-top: 1.5px;
}
.list-group-item:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.list-group-item:last-child {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid #f8f7ff;

  border-width: 1px 0;
}

@media (min-width: 768px) {
  .row-cols-md-10>* {
      flex: 0 0 auto;
      width: 10%;
  }
}

.exp-direc:hover,
.exp-direc:focus {
  outline: none;
  border: 1px solid #90caf9;
  background-color: #e3f2fd !important;
}
.exp-direc:active {
  outline: none;
  border: 1px solid #90caf9;
  
}
.playButton{
  display: none;
}
.exp-direc:hover .playButton {
  display: inline-block;
  transition: display 0.5s ease;
  position: relative;
  width: 50%;  
}
.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #001427;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.form-check{
  padding-left: 0;
}
.file-checkbox {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 10;
}
.form-check-input:checked ~ label>.card {
  border-color: #0d6efd;
}

.loading-overlay{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgb(1 22 39 / 65%);
  z-index: 100;
}


.collectionPane {
  height: calc(100vh - 115px);
  background: #fdfffc;
  overflow: auto;
  border-right: 1px solid #ccc;
  padding: 0 5px;
}
.collection-lists {
  padding: 15px;
  border: 1px solid #d1d5db;
  margin: 5px;
  border-radius: 8px;
  cursor: pointer;
}
.collection-lists svg.svg-icon-backend-type {
  fill: #021127;
  margin-right: 20px;
}
.collection-lists button{
  visibility: hidden;
}
.collection-lists:hover button{
  visibility: visible;
}
.collection-lists:hover, .collection-lists.active {
  background: #021127;
  border-color: #2c2a4a;
  color: #f9f9f9;
}
.collection-lists:hover svg.svg-icon-backend-type, .collection-lists.active svg.svg-icon-backend-type {
  fill: #f9f9f9;
}

.size-6{
  width: 20px;
  height: 20px;
}
/* .offcanvas, .offcanvas-lg, .offcanvas-md, .offcanvas-sm, .offcanvas-xl, .offcanvas-xxl {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 480px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
} */

.btn-n-list {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: space-around;
    justify-content: space-between;
    align-items: stretch;
}

  .container-dot {
    --uib-size: 43px;
    --uib-color: #f9f9f9;
    --uib-speed: 1.3s;
    --uib-dot-size: calc(var(--uib-size) * 0.24);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: var(--uib-dot-size);
    width: var(--uib-size);
  }

  .dot,
  .container-dot::before,
  .container-dot::after {
    content: '';
    display: block;
    height: var(--uib-dot-size);
    width: var(--uib-dot-size);
    border-radius: 50%;
    background-color: var(--uib-color);
    transform: scale(0);
    transition: background-color 0.3s ease;
  }

  .container-dot::before {
    animation: pulse var(--uib-speed) ease-in-out calc(var(--uib-speed) * -0.375)
      infinite;
  }

  .dot {
    animation: pulse var(--uib-speed) ease-in-out calc(var(--uib-speed) * -0.25)
      infinite both;
  }

  .container-dot::after {
    animation: pulse var(--uib-speed) ease-in-out calc(var(--uib-speed) * -0.125)
      infinite;
  }

  @keyframes pulse {
    0%,
    100% {
      transform: scale(0);
    }

    50% {
      transform: scale(1);
    }
  }

.cursor-pointer{
  cursor: pointer;
}

.video-player{
  width: 100%;
  max-height: 65vh;
  border-radius: 8px;
  background-color: #021127;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAMA;EACE;sEACoE;AACtE;;AAEA;EACE,oBAAoB;EACpB,gBAAgB,EAAE,qBAAqB;AACzC;AACA;EACE,SAAS;EACT,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,YAAY;AACd;AACA;EACE;AACF;;AAEA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;;AAElB;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,cAAc;EACd,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gFAAgF;EAChF,iCAAiC;EACjC,qBAAqB;EACrB,yCAAyC;EACzC,uDAAuD;;EAEvD,mBAAmB;AACrB;;AAEA;EACE;MACI,cAAc;MACd,UAAU;EACd;AACF;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,yBAAyB;;AAE3B;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,MAAM;EACN,OAAO;EACP,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,uCAAuC;AACzC;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,8BAA8B;EAC9B,YAAY;AACd;;;AAGA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;;;;;;;;;;;;;GAaG;;AAEH;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,8BAA8B;IAC9B,oBAAoB;AACxB;;EAEE;IACE,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,4CAA4C;IAC5C,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;IACX,cAAc;IACd,2BAA2B;IAC3B,0BAA0B;IAC1B,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE;cACU;EACZ;;EAEA;IACE;mBACe;EACjB;;EAEA;IACE;cACU;EACZ;;EAEA;IACE;;MAEE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;EACF;;AAEF;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap');\n@import \"./assets/styles/style_constants.css\";\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap\");\n\n\n\n:root {\n  font-family: \"Poppins\", \"Nunito\", -apple-system, BlinkMacSystemFont, \n    \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif !important;\n}\n\nhtml, body {\n  font-family: inherit;\n  font-weight: 400; /* Adjust as needed */\n}\nbody {\n  margin: 0; \n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\nhtml,body{\n  height: 100%;\n}\ncode {\n  font-family: var(--font-family)\n}\n\n.logo-w{\n  width: 135px;\n}\nli.cursor-pointer {\n  cursor: pointer;\n}\nli.explorer-list-group {\n  font-size: 0.9rem;  \n}\nli.explorer-list-group:hover{\n  background-color: #021127;\n  color: #e3f2fd;\n}\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n  color: #f8f9fa;\n  background: #212121;\n  border-radius: 10px;\n}\n.nav-link-annotator{\n  text-decoration: none;\n  color: white;\n  background: #0d6efd;\n}\n\nul.p-tree-container, \nul.p-treenode-children {\n  padding-left: 0px;\n}\nul.p-treenode-children{\n  border-left: 1px solid #dcdcdc;\n}\nul.p-treenode-children li{\n  padding-left: 10px;\n}\n.p-treenode-content {\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-size: 0.9rem;\n  width: 100%;\n}\n.p-tree .p-tree-container .p-treenode .p-treenode-content {\n  border-radius: 6px;\n  transition: box-shadow 0.2s;\n  padding: 0.25rem;\n \n}\nsvg.svg-icon.svg-file-type-icon {\n  width: 1.15rem;\n  height: 1.15rem;\n  margin-right: 0.5rem;\n}\nsvg.svg-file-explorer-icon{\n  width: 4.5rem;\n  height: 4.5rem;\n  margin: 0;\n}\n.p-splitter {\n  border: 0px solid #e5e7eb;\n  background: #ffffff;\n  border-radius: 0px;\n  color: #4b5563;\n}\n.p-tree {\n  border: 0px solid #e5e7eb;\n  background: #ffffff;\n  color: #4b5563;\n  padding: 0.125rem;\n  border-radius: 6px;\n  height: 100%;\n}\n.svg-icon-backend-type {\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n  margin-right: .75rem;\n}\n.svg-icon-backend-menu {\n  width: 18px;\n  height: 22px;\n  border-radius: 8px;\n  margin-right: 15px;\n  margin-top: 1.5px;\n}\n.list-group-item:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid #f8f7ff;\n\n  border-width: 1px 0;\n}\n\n@media (min-width: 768px) {\n  .row-cols-md-10>* {\n      flex: 0 0 auto;\n      width: 10%;\n  }\n}\n\n.exp-direc:hover,\n.exp-direc:focus {\n  outline: none;\n  border: 1px solid #90caf9;\n  background-color: #e3f2fd !important;\n}\n.exp-direc:active {\n  outline: none;\n  border: 1px solid #90caf9;\n  \n}\n.playButton{\n  display: none;\n}\n.exp-direc:hover .playButton {\n  display: inline-block;\n  transition: display 0.5s ease;\n  position: relative;\n  width: 50%;  \n}\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #001427;\n  --bs-backdrop-opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.form-check{\n  padding-left: 0;\n}\n.file-checkbox {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  z-index: 10;\n}\n.form-check-input:checked ~ label>.card {\n  border-color: #0d6efd;\n}\n\n.loading-overlay{\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  background: rgb(1 22 39 / 65%);\n  z-index: 100;\n}\n\n\n.collectionPane {\n  height: calc(100vh - 115px);\n  background: #fdfffc;\n  overflow: auto;\n  border-right: 1px solid #ccc;\n  padding: 0 5px;\n}\n.collection-lists {\n  padding: 15px;\n  border: 1px solid #d1d5db;\n  margin: 5px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.collection-lists svg.svg-icon-backend-type {\n  fill: #021127;\n  margin-right: 20px;\n}\n.collection-lists button{\n  visibility: hidden;\n}\n.collection-lists:hover button{\n  visibility: visible;\n}\n.collection-lists:hover, .collection-lists.active {\n  background: #021127;\n  border-color: #2c2a4a;\n  color: #f9f9f9;\n}\n.collection-lists:hover svg.svg-icon-backend-type, .collection-lists.active svg.svg-icon-backend-type {\n  fill: #f9f9f9;\n}\n\n.size-6{\n  width: 20px;\n  height: 20px;\n}\n/* .offcanvas, .offcanvas-lg, .offcanvas-md, .offcanvas-sm, .offcanvas-xl, .offcanvas-xxl {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 480px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1rem;\n  --bs-offcanvas-padding-y: 1rem;\n  --bs-offcanvas-color: var(--bs-body-color);\n  --bs-offcanvas-bg: var(--bs-body-bg);\n  --bs-offcanvas-border-width: var(--bs-border-width);\n  --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);\n  --bs-offcanvas-transition: transform 0.3s ease-in-out;\n  --bs-offcanvas-title-line-height: 1.5;\n} */\n\n.btn-n-list {\n    display: flex;\n    flex-wrap: nowrap;\n    flex-direction: row;\n    align-content: space-around;\n    justify-content: space-between;\n    align-items: stretch;\n}\n\n  .container-dot {\n    --uib-size: 43px;\n    --uib-color: #f9f9f9;\n    --uib-speed: 1.3s;\n    --uib-dot-size: calc(var(--uib-size) * 0.24);\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: var(--uib-dot-size);\n    width: var(--uib-size);\n  }\n\n  .dot,\n  .container-dot::before,\n  .container-dot::after {\n    content: '';\n    display: block;\n    height: var(--uib-dot-size);\n    width: var(--uib-dot-size);\n    border-radius: 50%;\n    background-color: var(--uib-color);\n    transform: scale(0);\n    transition: background-color 0.3s ease;\n  }\n\n  .container-dot::before {\n    animation: pulse var(--uib-speed) ease-in-out calc(var(--uib-speed) * -0.375)\n      infinite;\n  }\n\n  .dot {\n    animation: pulse var(--uib-speed) ease-in-out calc(var(--uib-speed) * -0.25)\n      infinite both;\n  }\n\n  .container-dot::after {\n    animation: pulse var(--uib-speed) ease-in-out calc(var(--uib-speed) * -0.125)\n      infinite;\n  }\n\n  @keyframes pulse {\n    0%,\n    100% {\n      transform: scale(0);\n    }\n\n    50% {\n      transform: scale(1);\n    }\n  }\n\n.cursor-pointer{\n  cursor: pointer;\n}\n\n.video-player{\n  width: 100%;\n  max-height: 65vh;\n  border-radius: 8px;\n  background-color: #021127;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
